<ng-container *ngIf="action$ | async"></ng-container>

<ng-container *ngIf="data$ | async">
  <mat-divider></mat-divider>

  <table mat-table #table [dataSource]="slots">
    <mat-text-column name="name" i18n-headerText headerText="Название"></mat-text-column>
    <mat-text-column name="designation" i18n-headerText headerText="Обозначение"></mat-text-column>
    <ng-container matColumnDef="plate">
      <th mat-header-cell *matHeaderCellDef i18n>Пласть</th>
      <td mat-cell *matCellDef="let row">
        <mat-form-field
          appearance="outline"
          (click)="$event.stopPropagation()"
          class="micro-input no-subscript no-label">
          <mat-select
            class="micro-input no-label no-subscript"
            appearance="outline"
            [value]="row.plate"
            (selectionChange)="setPlate(row, $event.value)"
            [disabled]="disabled">
            <mat-option [value]="0" i18n>Лицевая</mat-option>
            <mat-option [value]="1" i18n>Обратная</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef>
        <button mat-icon-button [disabled]="disabled" i18n-matTooltip matTooltip="Добавить паз" (click)="addSlot()">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="$event.stopPropagation(); delete(row, row.sideNumber)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['name', 'designation', 'plate', 'options']"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['name', 'designation', 'plate', 'options']"
      class="cursor-pointer"
      (click)="selection.toggle(row)"
      [ngClass]="{ 'bg-sky-100': selection.isSelected(row) }"></tr>
  </table>
</ng-container>
